// @flow
import { EventsContactsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    eventContact: {},
    listaEventsContacts: [],
    loading: false,
    error: false,
    formSubmited: false
};

type EventsContactsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { eventContact?: {} | null, listaEventsContacts?: [] | null, loading?: boolean, +value ?: boolean };

const EventsContacts = (state: State = INIT_STATE, action: EventsContactsAction): any => {
    // console.log(action);
    switch (action.type) {
        case EventsContactsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EventsContactsActionTypes.GET_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        eventContact: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EventsContactsActionTypes.LIST_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        listaEventsContacts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EventsContactsActionTypes.ADD_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventsContactsActionTypes.DELETE_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EventsContactsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EventsContactsActionTypes.GET_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventContact: {},
                        loading: false,
                    };
                }
                case EventsContactsActionTypes.LIST_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaEventsContacts: [],
                        loading: false,
                    };
                }
                case EventsContactsActionTypes.ADD_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventsContactsActionTypes.DELETE_EVENTS_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EventsContactsActionTypes.GET_EVENTS_CONTACTS:
            return { ...state, error: false, loading: true };
        case EventsContactsActionTypes.LIST_EVENTS_CONTACTS:
            return { ...state, error: false, loading: true };
        case EventsContactsActionTypes.ADD_EVENTS_CONTACTS:
            return { ...state, error: false, loading: true };
        case EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS:
            return { ...state, error: false, loading: true };
        case EventsContactsActionTypes.DELETE_EVENTS_CONTACTS:
            return { ...state, error: false, loading: true };
        case EventsContactsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                eventContact: {},
                listaEventsContacts: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default EventsContacts;
